// JavaScript source code
import './styles/Library.css';
import { useState, useRef, useEffect } from 'react';
import Dropdown from './components/library/Dropdown.js'
import GameCard from './components/library/Game.js'
import { GameCardInfo } from './components/library/Game.js'
import GameImageHeader from './GameImageHeader';
import { GetAuthStatus } from './Utilities.js';

function LibraryPage() {
    const [popupInfo, setPopupInfo] = useState(null);
    const [launchedLibrary, setLaunchedLibrary] = useState([]);
    const [comingSoonLibrary, setComingSoonLibrary] = useState([]);
    const [authStatus, setAuthStatus] = useState(false);

    useEffect(() => {
        const gameDataOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        setAuthStatus(GetAuthStatus());

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetGamesLibrary', gameDataOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    setLaunchedLibrary(data.message.filter((game) => game.DeveloperID !== 5));
                    setComingSoonLibrary(data.message.filter((game) => game.DeveloperID === 5));
                }
            });
    }, []);

    return (
        <div className="LibraryPage">
            <div className="titleLine">
                <GameImageHeader />
                <div className="topBody">
                    <div className="infoLibrary">
                        <h2 className="taglineTopLibrary">Explore</h2>
                        <h2 className="taglineBottomLibrary">Ludare Games</h2>
                        <p className="subTagLineLibrary">Explore new realms, challenge your skills, and find the <br /> perfect game for you.</p>
                        <button class="startButton" onClick={() => { (authStatus === true ? window.location.assign("/account/subscription") : window.location.assign("/login")); }}>Manage Your Subscription</button>
                    </div>
                </div>
            </div>

            {launchedLibrary.length > 0 && <div className='libraryTitle'>
                <h1> Supported</h1>
                <h1 style={{ color: '#FFCF00', marginLeft: '15px' }}>Games</h1>
            </div>}

            {launchedLibrary.length > 0 && <div className="catalogue">

                {launchedLibrary.map((gameInfo, index) => {
                    return <GameCard gameId={gameInfo.ID} gameInfo={gameInfo} />
                })}
            </div>}

            <div className='libraryTitle'>
                <h1> Coming Soon</h1>
            </div>

            <div className="catalogue">

                {comingSoonLibrary.map((gameInfo, index) => {
                    return <GameCard gameId={gameInfo.ID} gameInfo={gameInfo} />
                })}
            </div>


            {/* <div className='comingSoon'>
                <div className='comingTitle'>
                    <h1> Coming </h1>
                    <h1 className='soon'> Soon</h1>
                </div>
                <div>
                    <GameCard />
                </div> */}
            {/* </div> */}
        </div >
    );
}

export default LibraryPage;
